import { render, staticRenderFns } from "./CustomerDocumentsTab.vue?vue&type=template&id=755d379b&scoped=true"
import script from "./CustomerDocumentsTab.vue?vue&type=script&lang=ts"
export * from "./CustomerDocumentsTab.vue?vue&type=script&lang=ts"
import style0 from "./CustomerDocumentsTab.vue?vue&type=style&index=0&id=755d379b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755d379b",
  null
  
)

export default component.exports